module.exports = __webpack_public_path__ + "img/154.860172d2.jpg";